import React from "react";
import LinkHandler from "./NodeContents/LinkHandler.tsx";
import { NodeType } from "../models/types.ts";
import { DELAY_ONLY_BODY_SOURCES } from "../utils/BodyLinkRules.ts";

interface NodeHeaderProp {
  icon: string;
  name: string;
  type: NodeType;
}

// Node types whose body-level connector (auto-continue, or a "no reply within N minutes"
// timeout branch that runs alongside any buttons below) is rendered here, at the header —
// a single fixed location per node — rather than inside a content bubble. Bubbles can be
// added, removed, and reordered independently of this connector, so anchoring it to the
// bubble list would mean React Flow has to re-track which DOM element hosts it every time
// the content changes; anchoring it to the header instead means it never moves at all.
const BODY_DOT_TYPES = ["FLOW_START", "TEXT_BUTTON", "MEDIA_BUTTON", "LIST", "CAROUSEL", "TEMPLATE"];

const InfoDot: React.FC<{ tooltip: string }> = ({ tooltip }) => (
  <img
    src={require("../assets/node/smart-delay-info.png")}
    alt="info"
    title={tooltip}
    style={{ width: 14, height: 14, cursor: "help" }}
  />
);

const NodeHeader: React.FC<NodeHeaderProp | any> = ({ data }) => {
  const isSmartDelay = data.type === "SMART_DELAY";
  const isDelayOnlySource = DELAY_ONLY_BODY_SOURCES.includes(data.type);

  return (
    <div className="node-header" style={{ backgroundColor: "#ddf6ee" }}>
      {data.icon && <img src={data.icon} height={15} width={15} alt="icon" />}
      <span>{data.name}</span>
      {(isSmartDelay || isDelayOnlySource) && (
        // Pushed to the node's right edge — a hint sitting mid-header, right after the
        // name, reads as part of the title instead of a separate, hoverable affordance.
        <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
          {isSmartDelay && (
            <InfoDot tooltip="Pauses the flow for the set duration, then automatically continues to the next connected node." />
          )}
          {isDelayOnlySource && (
            <InfoDot tooltip="This node's connector can only link to a Smart Delay node — add one in between to continue the flow." />
          )}
        </div>
      )}
      {BODY_DOT_TYPES.includes(data.type) && <LinkHandler />}
    </div>
  )
}

export default NodeHeader;
